import { getLayout } from 'layouts/Default';
import { NextPageWithLayout } from './_app';
import TermsOfUse from 'templates/TermsAndPrivacy/TermsOfUse';

const TermsOfServicePage: NextPageWithLayout = () => {
  return <TermsOfUse />;
};

TermsOfServicePage.getLayout = getLayout;

export default TermsOfServicePage;
